
import GalleryHeader from "./website/gallery-components/GalleryHeader.jsx";
import GalleryCard from "./website/gallery-components/GalleryCard.jsx";

export default function Gallery() {
  return (
   <>
   <GalleryHeader />
   <GalleryCard />
   </>
  );
}